import {
  useState,
  useEffect,
  useImperativeHandle,
  useMemo,
  forwardRef,
} from "react";
import { createPortal } from "react-dom";
import { MentionItem } from "./MentionItem";

export const MentionList = forwardRef(
  ({ clientRect, query, editor, range, users }, ref) => {
    const [items, setItems] = useState([]);
    const [hoverIndex, setHoverIndex] = useState(0);

    const referenceEl = useMemo(
      () => (clientRect ? { getBoundingClientRect: clientRect } : null),
      [clientRect]
    );

    // Filter users based on query
    useEffect(() => {
      setItems(
        users.filter((user) =>
          user.name.toLowerCase().includes(query.toLowerCase())
        )
      );
      setHoverIndex(0);
    }, [query, users]);

    // Expose arrow key handling to parent
    useImperativeHandle(ref, () => ({
      onKeyDown: ({ event }) => {
        const key = event.key;
        if (key === "ArrowUp") {
          setHoverIndex((prev) => Math.max(prev - 1, 0));
          return true;
        }
        if (key === "ArrowDown") {
          setHoverIndex((prev) => Math.min(prev + 1, items.length - 1));
          return true;
        }
        if (key === "Enter") {
          event.preventDefault();
          handleSelect(hoverIndex);
          return true;
        }
        return false;
      },
    }));

    const handleSelect = (index) => {
      const selectedUser = items[index];
      if (!selectedUser) return;

      const { from, to } = range;

      editor
        .chain()
        .focus()
        .deleteRange({ from, to })
        .insertContent({
          type: "mention",
          attrs: { id: selectedUser.id, label: selectedUser.name },
        })
        .insertContent(" ")
        .run();
    };

    if (!items.length || !referenceEl) return null;

    return createPortal(
      <div
        style={{
          position: "absolute",
          top: referenceEl.getBoundingClientRect().bottom + window.scrollY + 2,
          left: referenceEl.getBoundingClientRect().left + window.scrollX,
          background: "#fff",
          border: "1px solid #ddd",
          borderRadius: "6px",
          padding: "2px 0",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          minWidth: "150px",
          zIndex: 9999,
        }}
      >
        {items.map((user, idx) => (
          <MentionItem
            key={user.id}
            isActive={idx === hoverIndex}
            onClick={() => handleSelect(idx)}
            onMouseEnter={() => setHoverIndex(idx)}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontWeight: 600 }}>{user.name}</span>
              <span style={{ fontSize: "12px", color: "#6b7280" }}>
                {user.email}
              </span>
            </div>
          </MentionItem>
        ))}
      </div>,
      document.body
    );
  }
);
